import { Table as DocumentsTable } from '@/components/document/table'
import { DocumentSubjectType } from '@/types'

interface Props {
  id: string
}

export const EditDocuments = ({ id }: Props) => {
  return (
    <>
      <DocumentsTable filters={{ subjectIdEq: id, subjectTypeEq: DocumentSubjectType.Asset }} pageSize={10} createable fixedHeight />
    </>
  )
}
